'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _defineProperty({}, MerchandiseIds.PRODUCT_SERVICE_FREE, {
  ownedByHub: false,
  selfServicePurchasable: false,
  eligibility: {
    isEligible: true,
    notEligibleReason: null
  },
  pricingWrap: {
    pricingType: 'FLAT',
    prices: [{
      value: 0,
      currencyCode: 'USD'
    }]
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/mockedFreeMerchandiseItems.js
// module id = 352
// module chunks = 3 4 5